// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"42b051d7","389":"621b0d95","732":"95b13c1c","977":"65afdff4"}[chunkId] + ".chunk.js";
};